import { createDeepEqualSelector } from '../../utils/selectors';

import { selectAuth } from '../selectors';

export const selectEmailConfirmation = createDeepEqualSelector(selectAuth, (auth) => auth.emailConfirmation);
